import PropTypes from "prop-types"
import React, { useState } from "react"
import { useMutation } from "react-query"

import Button from "src/components/Button"
import Form from "src/components/Form"
import Modal from "src/components/Modal"
import QRScanner from "src/components/QRScanner"

import { scanDockwaPayToken } from "src/api/DockwaPay"

import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

import ManualCodeEntry from "./ManualCodeEntry"

const DockwaPayModal = ({ onClose, handleSuccess }) => {
  const marinaSlug = getCurrentMarinaSlug()

  const [manualEntryCode, setManualEntryCode] = useState("")
  const [scanError, setScanError] = useState("")

  const { mutate: scanToken, isLoading } = useMutation({
    mutationFn: (code) => scanDockwaPayToken({ marinaSlug, code }),
    onSuccess: (data) => {
      handleSuccess(data)
      onClose()
    },
    onError: (error) => {
      setScanError(error.message)
    },
  })

  const resetManualEntry = () => {
    setManualEntryCode("")
    setScanError("")
  }

  const handleScan = (scanResult) => {
    resetManualEntry()

    scanToken(scanResult)
  }

  const handleManualCodeEntry = () => {
    scanToken(manualEntryCode)
  }

  return (
    <Modal size={"mediumFixed"} isOpen onClose={onClose}>
      <Modal.Header title="Dockwa Pay" />
      <Modal.Body>
        <div className="flex w-full flex-col space-y-6 pb-6">
          <QRScanner
            onScan={handleScan}
            onError={() =>
              setScanError(
                "An error has occurred. Please try again or contact support at mayday@dockwa.com."
              )
            }
            aspectRatio="3/2"
          />
          <ManualCodeEntry
            disabled={isLoading}
            handleSubmit={handleManualCodeEntry}
            value={manualEntryCode}
            setValue={setManualEntryCode}
          />
          {scanError && <Form.Error>{scanError}</Form.Error>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex flex-row items-center justify-between">
          <div className={"flex flex-row items-center space-x-2 text-gray-600"}>
            <span className="fa-kit fa-spinner fa-spin" />
            <span>
              {isLoading ? "Fetching customer info..." : "Awaiting Scan..."}
            </span>
          </div>
          <Button variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

DockwaPayModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
}
export default DockwaPayModal
